export default __webpack_public_path__ + "static/media/banner1.ab3f4e38.jpg";